module.exports = __webpack_public_path__ + "static/media/Delete-item.3467d0c0.svg";